export default __webpack_public_path__ + "static/media/icon-course-review.ab82b54b.svg";